module.exports = __webpack_public_path__ + "static/media/CC.e497d106.svg";